import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class NotificationService {
  public async getNoficationData(companyId: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/notificationData/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async getNoficationHistory(companyId: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/history/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async getNotificationHistory(companyId: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/history/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async addToSMSGroup(companyId: any, smsGroup: any) {
    let body = { name: smsGroup };
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/smsGroup/${companyId}`,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(body),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async addToEmailGroup(companyId: any, emailDetails: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/emailGroup/${companyId}`,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(emailDetails),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async deleteFromEmailGroup(companyId: any, emailDetails: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/emailGroup/${companyId}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(emailDetails),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async deleteAllSelectedFromEmailGroup(companyId: any, selectedList: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/emailGroup/delete/multiple/${companyId}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(selectedList),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }


  public async deleteAllSelectedFromSmsGroup(companyId: any, selectedList: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/smsGroup/delete/multiple/${companyId}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(selectedList),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async updateFromEmailGroup(companyId: any, notificationData: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/emailGroup/${companyId}`,
        {
          method: "PUT",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(notificationData),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async deleteFromSMSGroup(companyId: any, groupName: any) {
    let body = { name: groupName };
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/smsGroup/${companyId}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(body),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async updateFromSMSGroup(companyId: any, notificationData: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/notifications/smsGroup/${companyId}`,
        {
          method: "PUT",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(notificationData),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
}
